import { observer } from 'mobx-react-lite';

import { useTranslation } from '@gem/modules/i18n';
import { Popup } from '@gem/popups';

import { ShareDataView } from 'APP/main/PopupManager/components/ShareDataView/ShareDataView';

import usePresenter from './presenter';

const ShareMessageToPopup = () => {
  const { t } = useTranslation();

  const presenter = usePresenter();

  return (
    <Popup
      isOpened={presenter.isAvailableToShow}
      onClose={presenter.onClose}
      title={t('share_to')}
    >
      <ShareDataView onChangeSelection={presenter.onSelect} />
    </Popup>
  );
};

export default observer(ShareMessageToPopup);
